import React from "react";
import { Table, Pagination, Button, Dropdown, Menu } from "antd";
import "../../../../pages/Tickets/Tickets.scss";
import "./style.scss";
import { MoreOutlined } from "@ant-design/icons";
import { EyeIcon } from "../../../../icons";
import DrawerLayout from "../..";
import Input from "../../../form/input";

// const dummyData = [
//   {
//     key: "1",
//     idNo: "#412646",
//     title: "Animal Dead",
//     status: "Resolved",
//     invoiceNumber: "3495876",
//     assignedTo: "Zola Davu",
//   },
//   {
//     key: "2",
//     idNo: "#678357",
//     title: "Recycling request",
//     status: "New",
//     invoiceNumber: "9876543",
//     assignedTo: "Kwame Sade",
//   },
//   {
//     key: "3",
//     idNo: "#863765",
//     title: "Animal dead",
//     status: "Initiated",
//     invoiceNumber: "2345678",
//     assignedTo: "Zendaya Abeni",
//   },
//   {
//     key: "4",
//     idNo: "#275307",
//     title: "Bulk item",
//     status: "Closed",
//     invoiceNumber: "7890123",
//     assignedTo: "Zola Davu",
//   },
//   {
//     key: "5",
//     idNo: "#275378",
//     title: "Hazardous waste",
//     status: "Not Initiated",
//     invoiceNumber: "6789012",
//     assignedTo: "Kwame Sade",
//     overdue: true,
//     timer: "00:14:34",
//   },
//   {
//     key: "6",
//     idNo: "#228765",
//     title: "Compost service",
//     status: "Not Initiated",
//     invoiceNumber: "9012345",
//     assignedTo: "Ashanti Davu",
//     timer: "00:14:34",
//   },
//   {
//     key: "7",
//     idNo: "#863765",
//     title: "Missed collection",
//     status: "Parked",
//     invoiceNumber: "5678901",
//     assignedTo: "Amara Kwame",
//   },
//   {
//     key: "8",
//     idNo: "#678357",
//     title: "Overflow issues",
//     status: "Closed",
//     invoiceNumber: "4567890",
//     assignedTo: "Hibo Zendaya",
//   },
// ];

const STATUS_CLASS_MAP: { [key: string]: string } = {
  Resolved: "status-resolved",
  New: "status-new",
  Initiated: "status-initiated",
  Closed: "status-closed",
  "Not Initiated": "status-not-initiated",
  Parked: "status-parked",
};

const STATUS_MAP: Record<string, string> = {
  "1": "New",
  "28": "Not Initiated",
  "10": "Initiated",
  "31": "Parked",
  "23": "Rejected",
  "6": "Resolved",
  "3": "Closed",
};

interface ServiceRequestDrawerProps {
  open: boolean;
  setOpen: (value: boolean) => void;

  serviceHistory: any;

  searchKey: string;
  setSearchKey: (v: string) => void;

  selectedAccount: string;
  setSelectedAccount: (v: string) => void;

  currentPage: number;
  setCurrentPage: (v: number) => void;
}

const ServiceRequestDrawer: React.FC<ServiceRequestDrawerProps> = ({
  open,
  setOpen,
  serviceHistory,
  searchKey,
  setSearchKey,
  selectedAccount,
  setSelectedAccount,
  currentPage,
  setCurrentPage,
}) => {
  const DUMMY_ACCOUNTS = [
    "All",
    "3495876",
    "9876543",
    "2345678",
    "7890123",
    "6789012",
  ];

  /* ------------------ ACCOUNT DROPDOWN MENU ------------------ */
  const accountMenu = (
    <Menu
      onClick={(info) => setSelectedAccount(info.key)}
      items={DUMMY_ACCOUNTS.map((acc) => ({
        key: acc,
        label: acc,
      }))}
    />
  );

  const formattedData =
    serviceHistory?.tickets?.map((item: any, index: number) => {
      const statusKey = item.status_flg?.toString() || "1";
      const statusLabel = STATUS_MAP[statusKey] || "Unassigned";

      console.log("serviceHistory", serviceHistory);

      return {
        key: index,
        idNo: item.service_ticket_no,
        title: item.service_short_description,
        invoiceNumber: item.account_no ?? "-",
        status: statusLabel,
        createdOn: item.created_date,
        deliveredAt: item.delivered_at ?? "-",
      };
    }) || [];
  // ---------------------------------------------
  // TEMP: multiply backend data for pagination test
  // ---------------------------------------------
  const rawTickets = serviceHistory?.tickets || [];

  const multipliedTickets =
    rawTickets.length === 1
      ? Array.from({ length: 50 }, (_, i) => ({
          ...rawTickets[0],
          __fake_id: i + 1,
          service_ticket_no: `${rawTickets[0].service_ticket_no}-${i + 1}`,
        }))
      : rawTickets;

  // ---------------------------------------------
  // Format data for table
  // ---------------------------------------------
  // const formattedData = multipliedTickets.map((item: any, index: number) => {
  //   const statusKey = item.status_flg?.toString() || "1";
  //   const statusLabel = STATUS_MAP[statusKey] || "Unassigned";

  //   return {
  //     key: item.__fake_id ?? index,
  //     idNo: item.service_ticket_no,
  //     title: item.service_short_description,
  //     invoiceNumber: item.account_no ?? "-",
  //     status: statusLabel,
  //     createdOn: item.created_date,
  //     deliveredAt: item.delivered_at ?? "-",
  //   };
  // });

  const handleMenuClick = (info: any, record?: any) => {
    if (info?.key === "view") {
      console.log("View details for:", record?.idNo);
    }
  };

  const getActionMenu = (record: any) => (
    <Menu
      onClick={(info) => handleMenuClick(info, record)}
      items={[
        {
          key: "view",
          label: (
            <span className="flex justify-start items-center">
              <EyeIcon style={{ width: 16, height: 16, marginRight: 8 }} />
              View ticket
            </span>
          ),
        },
      ]}
    />
  );

  const columns = [
    {
      title: "ID no.",
      dataIndex: "idNo",
      key: "idNo",
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Account number",
      dataIndex: "invoiceNumber",
      key: "invoiceNumber",

      render: (text: string) => (
        <a href="#" style={{ color: "#377A86", textDecoration: "underline" }}>
          {text}
        </a>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (_: any, record: any) => {
        const cssClass = record.status.toLowerCase().replace(/\s+/g, "-");
        return (
          <span className={`status-pill ${cssClass}`}>{record.status}</span>
        );
      },
    },
    {
      title: "Created on",
      dataIndex: "createdOn",
      key: "createdOn",
    },

    {
      title: "Delivered date & time",
      dataIndex: "deliveredAt",
      key: "deliveredAt",
    },
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      width: 50,
      render: (_: any, record: any) => (
        <Dropdown overlay={getActionMenu(record)} trigger={["click"]}>
          <Button icon={<MoreOutlined />} type="text" />
        </Dropdown>
      ),
    },
  ];

  return (
    <DrawerLayout
      open={open}
      setOpen={setOpen}
      title="Service request history"
      width={1000}
      placement="right"
      closable
      footer={false}
      className="service-request-drawer"
    >
      <div className="tickets-table-header-container">
        <div className="tickets-header">
          <div className="services-header">
            <Input
              placeholder="Search..."
              className="services-search-input"
              value={searchKey}
              onChange={(e) => {
                setSearchKey(e.target.value);
                setCurrentPage(1); // reset pagination
              }}
            />

            <Dropdown overlay={accountMenu} trigger={["click"]}>
              <button className="service-type">
                Account number: {selectedAccount}
              </button>
            </Dropdown>
          </div>
        </div>

        <Table
          columns={columns}
          dataSource={formattedData}
          pagination={false}
          bordered={false}
          rowKey="key"
          className="custom-service-request-table"
        />

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 16,
          }}
        >
          <div style={{ fontSize: 13, fontWeight: 400, color: "#1E1E1E" }}>
            Page{" "}
            <input
              type="number"
              value={serviceHistory?.meta?.current_page || 1}
              min={1}
              max={serviceHistory?.meta?.last_page || 1}
              onChange={(e) => {
                const page = Number(e.target.value);
                if (
                  page >= 1 &&
                  page <= (serviceHistory?.meta?.last_page || 1)
                ) {
                  setCurrentPage(page);
                }
              }}
              style={{
                width: 40,
                padding: "2px 6px",
                border: "1px solid #ddd",
                borderRadius: 4,
                marginRight: 8,
              }}
            />
            of {serviceHistory?.meta?.last_page || 1}
          </div>
          <Pagination
            current={serviceHistory?.meta?.current_page || 1}
            pageSize={serviceHistory?.meta?.per_page || 10}
            total={serviceHistory?.meta?.total || 0}
            onChange={(page) => setCurrentPage(page)}
            showSizeChanger={false}
          />
        </div>
      </div>
    </DrawerLayout>
  );
};

export default ServiceRequestDrawer;
